// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RPGIconWithText__icon___bW88X {
    margin-right: 5px;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `RPGIconWithText__icon___bW88X`
};
module.exports = ___CSS_LOADER_EXPORT___;
